export default __webpack_public_path__ + "static/media/msg-user.047cd5ca.svg";